import React from "react";
import { FaSync } from "react-icons/fa";
import { SlHome } from "react-icons/sl";

export default function NavDownUI({
  displayHostname,
  homeText,
  regionText,
  homeHref,
  onRegionClick,
  regionFlag,
  usePillStyle = false,
}) {
  const summaryClass = usePillStyle
    ? "cursor-pointer list-none rounded-full bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100 px-3.5 py-1 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-slate-200/70"
    : "hust-media-text cursor-pointer list-none";

  return (
    <details className="relative inline-block [&_summary::-webkit-details-marker]:hidden [&_summary::marker]:hidden">
      <summary className={summaryClass}>
        {displayHostname}
      </summary>

      <div className="absolute right-2 mt-1 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
        <a
          href={homeHref}
          className="flex block gap-1 px-4 py-2 text-sm hover:bg-gray-100 text-black no-underline"
        >
          {homeText} <SlHome className="mt-1 text-xs cursor-pointer" />
        </a>
        <button
          type="button"
          onClick={onRegionClick}
          className="flex block gap-1 px-4 py-2 text-sm hover:bg-gray-100 text-black no-underline"
        >
          {regionText} {regionFlag} <FaSync className="mt-1 text-xs cursor-pointer" />
        </button>
      </div>
    </details>
  );
}
